// extracted by mini-css-extract-plugin
module.exports = {"buttonA11Y":"style_buttonA11Y__odUNV","buttonA11Y__loading":"style_buttonA11Y__loading__HB5vi"};